<template>
  <div class="home">
    <div class="container"></div>
<!--    <img src="../assets/Yufa_Logo_white_200_2_b.svg" />  -->
    <svg viewBox="0 0 2000 2000">
      <path class="path" d="M479 1788 c-30 -46 -59 -92 -65 -103 -6 -11 -22 -39 -37 -62 -15 -24
        -27 -51 -27 -61 0 -17 97 -202 167 -317 53 -89 123 -214 123 -222 0 -13 61
        -127 80 -148 9 -11 37 -59 60 -108 l44 -87 178 0 c153 0 178 2 178 15 0 9 -24
        62 -54 118 l-55 102 91 153 90 154 -18 41 c-18 40 -74 130 -130 211 -26 37
        -28 38 -42 20 -12 -16 -114 -176 -148 -231 -7 -10 -13 -16 -16 -13 -16 20
        -112 168 -147 228 -48 80 -48 70 4 157 13 22 40 70 59 107 20 36 40 69 46 73
        5 3 10 17 10 31 l0 24 -169 0 -168 0 -54 -82z m381 58 c0 -8 -4 -17 -9 -20 -5
        -4 -33 -50 -61 -103 -29 -54 -61 -109 -71 -122 -11 -13 -19 -33 -19 -44 0 -33
        171 -306 197 -314 6 -2 16 2 23 9 9 11 110 166 145 224 9 14 15 10 39 -27 16
        -24 41 -62 56 -84 15 -22 39 -63 53 -91 l25 -50 -91 -154 -91 -154 55 -104
        c30 -57 56 -107 57 -113 2 -5 -65 -9 -165 -9 l-169 0 -44 87 c-23 49 -51 97
        -60 108 -19 21 -80 135 -80 148 0 8 -70 133 -123 222 -55 91 -167 299 -167
        310 0 5 16 34 35 62 19 29 35 55 35 58 0 4 13 25 29 48 16 23 41 61 55 85 l26
        42 160 0 c133 0 160 -2 160 -14z"/>
      <path class="path2" d="M1090 1861 c0 -6 15 -36 34 -68 18 -32 61 -112 95 -178 74 -143 178
        -341 254 -484 l55 -103 -110 -196 c-60 -107 -114 -205 -118 -216 -5 -12 -17
        -31 -27 -44 l-18 -22 -274 2 -274 3 -29 55 c-16 30 -50 96 -75 145 -26 50 -54
        101 -64 115 -9 14 -37 63 -61 110 -25 47 -64 121 -88 165 -24 44 -58 110 -77
        147 -19 36 -40 71 -46 76 -9 7 -46 -41 -135 -173 l-124 -183 20 -29 c39 -58
        73 -115 114 -198 12 -22 28 -51 38 -65 19 -28 62 -105 128 -230 24 -47 76
        -138 114 -202 l70 -118 639 0 639 0 0 174 0 174 -30 7 c-16 4 -30 10 -30 13 0
        4 20 37 43 73 24 36 59 93 77 125 18 32 53 89 77 126 23 37 51 83 60 103 16
        34 16 36 -13 92 -16 31 -51 95 -78 142 -27 47 -60 106 -74 131 -14 25 -73 131
        -132 235 -59 105 -121 216 -136 247 l-29 57 -207 1 c-125 0 -208 -4 -208 -9z
        m434 -59 c15 -31 77 -142 136 -247 59 -104 118 -210 132 -235 14 -25 45 -79
        68 -120 84 -146 109 -200 102 -219 -4 -9 -31 -55 -60 -102 -126 -199 -202
        -328 -202 -342 0 -9 13 -18 30 -22 l30 -7 0 -164 0 -164 -629 0 -629 0 -70
        118 c-38 64 -90 155 -114 202 -69 129 -109 202 -130 232 -10 15 -25 42 -34 60
        -8 18 -28 56 -44 83 -16 28 -39 67 -50 87 -11 20 -24 39 -30 43 -5 3 17 43 49
        88 31 45 84 121 116 170 32 48 61 87 66 87 4 0 23 -30 42 -67 18 -38 53 -104
        77 -148 24 -44 63 -118 88 -165 24 -47 52 -96 61 -110 10 -14 37 -63 61 -110
        23 -47 54 -105 68 -130 49 -87 22 -80 332 -80 l276 0 22 30 c12 16 22 32 22
        35 0 4 47 91 105 194 58 103 105 192 105 198 0 6 6 13 13 16 13 4 -16 66 -168
        352 -46 88 -112 213 -145 277 -33 64 -73 139 -90 167 l-29 51 197 0 197 -1 29
        -57z"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style scoped lang="stylus">
img
  width:  25%;
  height: 25%;
  margin-top:   10vmin;
  margin-left:  -10vmin;
  margin-bottom:  -10vmin;
  rotate: 45deg;

svg
  width: 267pt;
  height: 267pt;
  scale: 1 -1;
  margin: 10vmin auto 0vmin auto;
  //animation:  rotate 3s linear infinite;

#circle
  visibility: hidden;
.path
  stroke-dasharray: 100;
  stroke-dashoffset: 1000;
  animation: dash 1s linear alternate infinite;
  fill: rgba(255, 255, 255,.1);
  stroke: #0151a3;
  stroke-width: 7;

.path2
  stroke-dasharray: 50;
  stroke-dashoffset: 1000;
  animation: dash 1s linear alternate infinite;
  fill: rgba(255, 255, 255,.1);
  stroke: #060C44;
  stroke-width: 7;

@keyframes dash
  from
    stroke-dashoffset: 822;
  
@keyframes rotate
  0%
    transform:  rotateY(0deg);
  100%
    transform:  rotateY(360deg);
    
@keyframes rotate_s
  0%
    transform: rotateY(0deg);
    position: relative;
    left: 8vmin;
    top:  0vmin;
  25%
    position: relative;
    left: -4vmin;
    top:  4vmin;
  50%
    transform: rotateY(360deg);
    position: relative;
    left: 0vmin;
    top:  8vmin;
  75%
    position: relative;
    left: -4vmin;
    top:  4vmin;
  100%
    transform: rotateY(0deg);
    position: relative;
    left: 8vmin;
    top:  0vmin;

.dot
  width:  35px;
  height: 35px;
  position: absolute;
  background: url(https://image.ibb.co/kyUHab/rose.png);
  background-size:  100% 100%;
  transform: matrix3d();
</style>
